import Button from './Button.svelte'
import CTABox from './CTABox.svelte'
import Image from './Image.svelte'
import Text from './Text.svelte'

export default { Button, Image, Text, CTABox }
